import DebitCardDetails from '@sunbit-dev/common/models/IDebitCardDetails';
import {
  Init as NetworkServiceInit,
  NetworkServiceError,
  Request as NetworkServiceRequest,
} from '@sunbit-dev/purchase-common/src/services/networkService/models';
import Customer from '@sunbit-dev/common/models/ICustomer';
import { PinCodeMethod } from '@sunbit-dev/purchase-common/src/models/PinCodeMethod';
import { EventsNames } from '~/enums/Events';
import { WorkflowState } from '~/models/WorkflowState';

export enum BackendService {
  Purchase = 'purchase-service',
  LoanApplication = 'loan-application-service',
}

export interface Init extends Omit<NetworkServiceInit, 'baseUrl'> {
  baseUrls: Record<BackendService, string>;
  onAuthenticationRequired: () => void;
  onWorkflowState?: (workflowState: WorkflowState) => void;
}

export interface LoanApplicationRequest extends NetworkServiceRequest {
  service: BackendService;
}

export interface WithWorkflowState {
  _workflowState?: WorkflowState;
}

export interface CheckPurchaseAmountResponse {
  purchaseAmount?: number;
  wantedAmount: number;
}

export type OnRefreshFailure = ({ error }: { error: NetworkServiceError }) => Promise<void>;

export interface LoginResponse {
  token: string;
  customer?: Customer;
  expiresIn: number;
}

export interface ValidateUserResponse {
  customer?: Customer;
}

export interface ApprovedUserResponse extends ValidateUserResponse {
  proveDenied: boolean;
}

export interface LoginArguments {
  pinCodeMethod?: PinCodeMethod;
  verificationCode?: string;
  eventName: string;
  onRefreshFailure: OnRefreshFailure;
}

export interface CompleteEstimateArguments {
  purchaseId: number;
  eventName: EventsNames;
}

export interface SendOTPArguments {
  pinCodeMethod?: PinCodeMethod;
  phoneNumber?: string;
  eventName: string;
}

export interface DocumentPage {
  content: string;
  mimeType: string;
  name: string;
}

export interface NoaaDocument {
  name?: string;
  content?: string;
  noaaType: string;
  notificationType?: string;
  offerId: number;
  purchaseId: number;
}

export interface NotificationDocument {
  name?: string;
  content?: string;
  notificationType: string;
  offerId: number;
  purchaseId: number;
}

export interface Noaa5Document {
  name?: string;
  content?: string;
  offerId: number;
  purchaseId: number;
  noaaType: string;
}

export interface UpdatePaymentMethod {
  offerId: number;
  creditCard: DebitCardDetails;
  isRccPurchase: boolean;
  isMailPaymentMethod: boolean;
  paymentMethodType: string;
  accountNumber?: string;
  routingNumber?: string;
}

export interface ValidateDebitCard {
  offerId: number;
  creditCard: DebitCardDetails;
}

export interface IApplyCharge {
  paymentPlanId: number;
}

interface AdditionalPaymentPayload {
  amount: string;
  paymentMethod: string;
}

export interface ChangeDownPaymentArgs {
  totalAmount: number;
  additionalPayments: AdditionalPaymentPayload[];
  offerId: number;
}

export interface CustomerVerificationLinkResponse {
  link: string;
}

export interface CreatePrequalApplicationResponse {
  link: string;
  shortToken: string;
  expirationDateTime: string;
}
